import { Loader2, X } from "lucide-react";
import { fmt } from "@/lib/studioUtils";

const redBtn = "w-full bg-red-600 hover:bg-red-700 disabled:opacity-40 disabled:hover:bg-red-600 shadow-[0_0_25px_rgba(220,38,38,0.25)] text-white text-sm font-semibold rounded-[4px] py-3 transition-colors";

// Enter Comment, Choose Voice and Publish Video under the video, plus a status bar while the video is being made or uploaded.
export function UnderVideoBar({ onPublish, onEnterComment, onChooseVoice, disabled, status, elapsed, speaking, onCancel }) {
  return (
    <section className="mt-4 flex flex-col gap-2" data-testid="under-video-bar">
      <div className="grid grid-cols-3 gap-2">
        <button onClick={onEnterComment} disabled={disabled} data-testid="enter-comment-btn" className={redBtn}>Enter Comment</button>
        <button onClick={onChooseVoice} disabled={disabled} data-testid="choose-voice-btn" className={redBtn}>Choose Voice</button>
        <button onClick={onPublish} disabled={disabled} data-testid="publish-video-btn" className={redBtn}>Publish Video</button>
      </div>
      {status === "recording" && (
        <div data-testid="recording-indicator" className="w-full bg-black text-white text-sm font-semibold rounded-[4px] py-2 pl-4 pr-2 flex items-center justify-between gap-3">
          <span className="flex items-center gap-2.5">
            <span className="w-2.5 h-2.5 rounded-full bg-yellow-400 animate-pulse" data-testid="recording-dot" />
            {speaking ? "Recording · voice speaking" : "Recording"}
            <span className="font-mono text-white/80" data-testid="rec-timer">{fmt(elapsed)}</span>
          </span>
          <button type="button" onClick={onCancel} data-testid="cancel-recording-btn"
            className="flex items-center gap-1 text-xs font-medium text-white/80 hover:text-white border border-white/20 hover:border-white/50 rounded-[4px] px-3 py-1.5 transition-colors">
            <X size={13} /> Cancel
          </button>
        </div>
      )}
      {status && status !== "recording" && (
        <div data-testid="status-indicator" className="w-full bg-zinc-100 text-zinc-700 text-sm font-medium rounded-[4px] py-3 flex items-center justify-center gap-2">
          <Loader2 size={14} className="animate-spin" /> {status}
        </div>
      )}
    </section>
  );
}
